var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51913 11.7915C1.65913 11.7915 1.68713 11.7775 1.81313 11.7495L4.33313 11.2455C4.59913 11.1755 4.86513 11.0495 5.07513 10.8395L11.1791 4.7355C12.1171 3.7975 12.1171 2.1875 11.1791 1.2495L10.6611 0.7035C9.72313 -0.2345 8.09913 -0.2345 7.16113 0.7035L1.05713 6.8215C0.861128 7.0175 0.721128 7.2975 0.651128 7.5635L0.119128 10.1115C0.0491279 10.5875 0.189128 11.0495 0.525128 11.3855C0.791128 11.6515 1.18313 11.7915 1.51913 11.7915ZM1.99513 7.8295L8.09913 1.7115C8.50513 1.3055 9.24713 1.3055 9.63913 1.7115L10.1711 2.2435C10.6471 2.7195 10.6471 3.3915 10.1711 3.8535L4.08113 9.9715L1.49113 10.4055L1.99513 7.8295Z",
    fill: "url(#paint0_linear_1229_3587)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1231 12.6562H0.791141C0.385141 12.6562 0.119141 12.9222 0.119141 13.3282C0.119141 13.7342 0.455141 14.0002 0.791141 14.0002H11.0671C11.4731 14.0002 11.8091 13.7342 11.8091 13.3282C11.7951 12.9222 11.4591 12.6562 11.1231 12.6562Z",
    fill: "url(#paint1_linear_1229_3587)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1229_3587",
    x1: 11.519,
    y1: 20.295,
    x2: -2.64784,
    y2: 18.7387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1229_3587",
    x1: 11.4483,
    y1: 14.9695,
    x2: 4.01762,
    y2: 7.86306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e230c8be0afae9826b1bb1a6d75b480c.svg";
export { ForwardRef as ReactComponent };